import { createContext } from 'react';
import { Subject } from 'rxjs';

const dummyLoggedInTeamMemberContext = new Subject() as Subject<string>;

const RefetchSubjectContext = createContext(dummyLoggedInTeamMemberContext);

export default RefetchSubjectContext;
